// extracted by mini-css-extract-plugin
export default {"Emoji":"bcb_a bie_i bie_q bie_j"};